const DR_SESSION = 'DR_SESSION';
const DR_RENEW_AGENT_TOKEN_INTERVAL_IN_MINUTES = 20;

export {
    DR_RENEW_AGENT_TOKEN_INTERVAL_IN_MINUTES,
    DR_SESSION,
}
